// extracted by mini-css-extract-plugin
module.exports = {"Wrap":"ChatModeration_Wrap__VqVGi"};